// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import classReducer from './ClassSlice';
import SectionSlice from './SectionSlice';
import RoleSlice from './RoleSlice';
import UserSlice from './UserSlice';
import SessionSlice from './SessionSlice';
import DepartmentSlice from './DepartmentSlice';
import DesignationSlice from './DesignationSlice';
import HouseSlice from './HouseSlice';
import TeacherSlice from './TeacherSlice';
import SubjectSlice from './SubjectSlice';
import LeaveSlice from './LeaveSlice';
import HostelLeaveSlice from './HostelLeaveSlice';
import TimeTableSlice from './TimeTableSlice';
import AttendenceSlice from './AttendenceSlice';
import NoticeBoardSlice from './NoticeBoardSlice';
import StudentSlice from "./StudentSlice";
import SyllabusSlice from "./syllabusSlice";
import TokenPermissionSlice from './TokenPermissionSlice';
import StudentCategorySlice from './StudentCategorySlice';
import ClubSlice  from "./ClubSlice"
import HostelCategorySliice from "./HostelCategorySlice"
import HostelRoomSliice from "./HostelRoomSlice"
import DormitorySliice from "./DormitorySlice"
import DormitoryRoomSliice from "./DormitoryRoomSlice"
import ParentSliice from "./ParentSlice"
import EventSlice from "./EventSlice"
import FeedbackSlice from "./FeedbackSlice"
import ExamTypeSlice from "./ExamTypeSlice"
import ExamGradeSlice from "./GradeScaleSlice"
import ExamSlice from "./ExamSlice"
import AdmitCardSlice from "./AdmitCardSlice"
import ResultSlice from "./ResultSlice"
import PayrollSlice from "./PayrollSlice"
import PromotionSlice from "./PromotionSlice"
import StudentFeeSlice from "./StudentFeeSlice"
import EnquirySlice from './EnquirySlice';
import EnquiryTypeSlice from './EnquiryTypeSlice';
import ExpenseSlice from './ExpenseSlice';
import ExpenseTypeSlice from './ExpenseTypeSlice';
import EarningSlice from './EarningSlice';
import EarningTypeSlice from './EarningTypeSlice';
import StudentEnquirySlice from './StudentEnquirySlice';
import PhotoGallerySlice from "./PhotoGallerySlice";
import ClassRoomSlice from "./ClassRoomSlice"
import QRCodeSlice from "./QRCodeSlice"
import SchoolSlice from "./SchoolSlice"
import MeetingSlice from "./MeetingSlice"
import VendorSlice from "./VendorSlice"
import AddProductCategorySlice from './AddProductCategorySlice';
import ProductSlice from "./ProductSlice"
import wishlistSlice from "./wishlistSlice"
import cartSlice from "./CartSlice"
import assignFeeSlice from "./AssignFeeSlice"
import FeeDiscountSlice from "./FeeDiscountSlice"
import AccessMethodSlice from "./AccessMethodSlice"
import GateTypeSlice from "./GateTypeSlice"
import GatePassSlice from "./GatePassSlice"
import VisitorSlice from "./VisitorSlice"
import RoleBaseUserSlice from "./RoleBaseUserSlice"
import VehicleSlice from "./VehicleSlice"
import BusStationSlice from "./BusStationSlice"
import AssessmentSlice from "./AssessmentSlice"
import HomeworkSlice from "./HomeWorkSlice"
// import feeDiscountesSlice from "./FeeDiscountsSlice"
import ExamSubjectFieldSlice   from "./ExamSubjectFieldSlice"
import StudentRegistrationSlice from "./StudentRegistrationSlice"
import FeeTypeSlice from "./FeeTypeSlice"
import FeePackageSlice from "./FeePackageSlice"
import BankAccountSlice from "./BankAccountSlice"
import DeviceRegisterSlice from "./DeviceRegisterSlice";
import AssignmentSlice from "./AssignmentSlice";
import SubmissionSlice from "./SubmissionSlice";
import OtherInvoiceSlice from "./OtherInvoiceSlice";
import ReportConfigSlice from "./ReportConfigSlice";
import CertificateTemplateSlice from "./CertificateTemplateSlice";
import EmpAttendanceSlice from "./EmpAttendanceSlice"
import StaffTaskSlice from "./StaffTaskSlice"
import InventoryCategorySlice from "./InventoryCategorySlice"
import InventorySubCategorySlice from "./InventorySubCategorySlice"
import InventoryUnitSlice from "./InventoryUnitSlice"
import InventoryItemSlice from "./InventoryItemSlice"
import ManualGatePassSlice from "./ManualGatePassSlice"
import MaintenanceSlice from "./MaintenanceSlice"
import CoActivitySlice from "./CoActivitySlice"

const store = configureStore({


  reducer: {
    classes: classReducer,
    sections: SectionSlice,
    roles: RoleSlice,
    users: UserSlice,
    houses: HouseSlice,
    sessions: SessionSlice,
    departments: DepartmentSlice,
    designations: DesignationSlice,
    teachers: TeacherSlice,
    subjects: SubjectSlice,
    leaves: LeaveSlice,
    timetables: TimeTableSlice,
    attendences: AttendenceSlice,
    hostelleaves: HostelLeaveSlice,
    noticeboards: NoticeBoardSlice,
    students: StudentSlice,
    syllabus: SyllabusSlice,
    feedbacks:FeedbackSlice,
    checkpermissions: TokenPermissionSlice,
    studentcategorys:StudentCategorySlice,
    clubs:ClubSlice,
    hostelcategorys:HostelCategorySliice,
    hostelrooms:HostelRoomSliice,
    dormitorys:DormitorySliice,
    dormitoryrooms:DormitoryRoomSliice,
    parents:ParentSliice,
    events:EventSlice,
    examtypes:ExamTypeSlice,
    examgrades:ExamGradeSlice,
    exams:ExamSlice,
    admitcards:AdmitCardSlice,
    examresults:ResultSlice,
    payrolls:PayrollSlice,
    promotions:PromotionSlice,
    bankaccounts:BankAccountSlice,
    coactivitys:CoActivitySlice,
    // feeterms:FeeTermSlice,
    // feenotes:FeeNoteSlice,
    // feestructures:FeeStructureSlice,
    studentfees:StudentFeeSlice,
    enquirys:EnquirySlice,
    enquirytypes:EnquiryTypeSlice,
    earnings:EarningSlice,
    earningtypes:EarningTypeSlice,
    expenses:ExpenseSlice,
    expensetypes:ExpenseTypeSlice,
    studentenquirys:StudentEnquirySlice,
    gallerys:PhotoGallerySlice,
    classrooms:ClassRoomSlice,
    qrcodes:QRCodeSlice,
    schools:SchoolSlice,
    meetings:MeetingSlice,
    vendors:VendorSlice,
    productcategorys:AddProductCategorySlice,
    products:ProductSlice,
    whishlists:wishlistSlice,
    cart:cartSlice,
    assignfee:assignFeeSlice,
    feediscounts:FeeDiscountSlice,
    feetypes:FeeTypeSlice,
    studentregistrations:StudentRegistrationSlice,
    otherinvoices:OtherInvoiceSlice,
    reportconfigs:ReportConfigSlice,
    empattendances:EmpAttendanceSlice,
    accessmethods: AccessMethodSlice,
    gatetypes: GateTypeSlice,
    deviceregisters:DeviceRegisterSlice,
    gatepasss: GatePassSlice,
    visitors:VisitorSlice,
    rolebyusers:RoleBaseUserSlice,
    vehicles:VehicleSlice,
    busStations:BusStationSlice,
    assessments:AssessmentSlice,
    homeworks:HomeworkSlice,
    assignments:AssignmentSlice,
    submissions:SubmissionSlice,
    feepackages:FeePackageSlice,
    // feediscount:feeDiscountesSlice,
    // studentwallet:studentWalletSlice,
    // payment:paymentSlice,
    // transportwallet:transportwalletSlice,
    examsubjectfields:ExamSubjectFieldSlice,
    certitemplates:CertificateTemplateSlice,
    stafftasks:StaffTaskSlice,
    inventorycategorys:InventoryCategorySlice,
    inventorysubcategorys:InventorySubCategorySlice,
    inventoryunits:InventoryUnitSlice,
    inventoryitems:InventoryItemSlice,
    manualgatepasss:ManualGatePassSlice,
    maintenances:MaintenanceSlice,
  },
});

export default store;
